import { type FC, type ReactNode, useContext } from "react";
import { css } from "@stubhub/broadway-foundation/css";
import { SecondRow } from "src/website-apps/shared/components/header/SearchEmphasizedBrowseHeader/styled-components";
import { MegaSearch } from "src/website-apps/shared/components/instant-search-redesign-mega-search/MegaSearch";
import { withSearchContext } from "src/website-apps/shared/components/search/context";
import { RecentSearchesProvider } from "src/website-apps/shared/components/search/recent-searches/MaybeWithRecentSearchesProvider";
import { SearchTermContext } from "src/website-apps/shared/context/SearchTermContext";

interface Props {
  greeting?: ReactNode;
  belowSearch?: ReactNode;
}

const searchGutter = css({
  paddingInline: "primitives.200",
  tablet: {
    paddingInline: "primitives.400",
  },
});

const HomeEmphasizedSearchComponent: FC<Props> = ({ greeting, belowSearch }) => {
  const initialSearchTerm = useContext(SearchTermContext);

  return (
    <RecentSearchesProvider>
      <div className={searchGutter}>
        {greeting}
        <SecondRow>
          <MegaSearch initialSearchTerm={initialSearchTerm} shouldAutoFocus={false} />
        </SecondRow>
        {belowSearch}
      </div>
    </RecentSearchesProvider>
  );
};

/** The control header's large search row, rendered standalone below the Ensemble AppNav. */
export const HomeEmphasizedSearch = withSearchContext(HomeEmphasizedSearchComponent);
